
import styles from './details.module.css';
export function Details({ question, sub_question, answer }) {
  return (
    <details className={styles.details} name="faq">
      <summary className={styles.question}>{question}</summary>
      <div className={styles.wrapper}>
        <p className={styles.sub_question}>{sub_question}</p>
        <p>{answer}</p>
      </div>
    </details>
  );
}
